// extracted by mini-css-extract-plugin
export var button = "ProgramSelector-module__button___R3iRL";
export var cost = "ProgramSelector-module__cost___pDpmS";
export var descriptorContent = "ProgramSelector-module__descriptorContent___Ncs9O";
export var descriptorTitle = "ProgramSelector-module__descriptorTitle___XOhdh";
export var disabled = "ProgramSelector-module__disabled___igdyU";
export var doubleColumn = "ProgramSelector-module__doubleColumn___uJxEJ";
export var image = "ProgramSelector-module__image___IJHqH";
export var imageColumn = "ProgramSelector-module__imageColumn___74aWc";
export var large = "1084px";
export var largeColumn = "ProgramSelector-module__largeColumn___Uj0Af";
export var medium = "860px";
export var programBox = "ProgramSelector-module__programBox___R4wIA";
export var programInfoWrapper = "ProgramSelector-module__programInfoWrapper___HCsaR";
export var programName = "ProgramSelector-module__programName___i6mBg";
export var rightSideLink = "ProgramSelector-module__rightSideLink___bng2t";
export var rowProgramDescriptionPriceContainer = "ProgramSelector-module__rowProgramDescriptionPriceContainer___Hqb9p";
export var screenReaderOnly = "ProgramSelector-module__screenReaderOnly___CBg4B";
export var small = "540px";